export default __webpack_public_path__ + "static/media/SmallPhone.5ad52802.svg";